<template>
  <PSServiceState />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
